export interface IAppState { }

export const DEFAULT_APP_STATE: IAppState = {};
